//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import textField from '../ui/text-field.vue';

export default {
    name: 'FormsContact',
    components: { textField },
    props: {
        action: {
            type: String,
            default: 'https://formspree.io/f/xdovlldg',
        },
        sendText: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            formAction: this.action,
            formData: {
                name: '',
                email: '',
                phone: '',
            },
            status: null,
        };
    },
    methods: {
        handleSubmit(event) {
            const { formElement } = this.$refs;
            const data = new FormData(event.target);

            fetch(event.target.action, {
                method: formElement.method,
                body: data,
                headers: {
                    Accept: 'application/json',
                },
            })
                .then((response) => {
                    if (response.ok) {
                        this.status = this.$t('form.success');
                        this.formData = {
                            name: '',
                            email: '',
                            phone: '',
                        };
                    } else {
                        response.json().then((responseData) => {
                            if (Object.hasOwn(responseData, 'errors')) {
                                this.status = responseData.errors
                                    .map((error) => error.message)
                                    .join(', ');
                            } else {
                                this.status = this.$t('form.error');
                            }
                        });
                    }
                })
                .catch(() => {
                    this.status = this.$t('form.error');
                });
        },
    },
};
